import {Badge} from "react-bootstrap";
import React from "react";
import Icon from '@mdi/react';
import {mdiCheck, mdiCommentAlert, mdiMapMarkerAlertOutline} from "@mdi/js";

export default function CommentInfoTableCell({ id,className,children,rowData,...rest }) {

      return (
        <td {...rest} key={id} className={`border px-4 py-2 cursor-pointer text-nowrap ${className ? " " + className : ""}`}>
            {children}
            {rowData.has_comment ? <Icon color={"#ffcd29"} path={mdiCommentAlert} size={1} /> : null}
            {rowData.address_warning ? <Icon color={"#cd0606"} path={mdiMapMarkerAlertOutline} size={1} /> : null}
            {rowData.manual_state===1 ? <Icon color={"#09e309"} path={mdiCheck} size={1} /> : null}
        </td>

      );
  }
